import { GetInterviewedFacilitiesInputDto, GetInterviewedFacilitiesDto } from '../dto/interviewedFacilitiesDto'
import { executeGet } from '../common/apiCaller'

const apiName = 'citizen'
const apiPath = '/interviewed-facilities'

export const executeGetInterviewedFacilities = (input: GetInterviewedFacilitiesInputDto) => {
  return executeGet<GetInterviewedFacilitiesDto[]>(apiName, apiPath, input)
}
